import React, { Suspense, memo, lazy, useEffect, useState } from "react";
import { Switch, withRouter, Route, Redirect } from "react-router-dom";
import routes from "../../routes";
import Loading from "components/Loading";
import AppRoute from "./AppRoute";
import { ContainerStyled } from "./style";
import BottomMenu from "components/BottomMenu/BottomMenu";
import MoodModal from "components/MoodModal";
import ModalPrivacy from "components/ModalPrivacy";
import { isAuthenticated } from "services/Auth";
import { isEmbeded } from "services/config/EmbededService";
import AddToHomeScreemServiceWorker from './AddToHomeScreemServiceWorker'
import pathAfterLogin from "services/pathAfterLogin";
import SSOService from "services/sso/SSOService";
import { getToken } from "services/Auth";
import {ProfileService} from "services/index";
import ChannelSyncActivator from "components/Channels/Sidebar/ChannelSyncActivator";
import { shouldShowMoodModalOnLogin } from "commons/utils/moodModal";
import { resolveTermsOfUseVisibility } from "commons/utils/privacyModal";
import PushFromNativeBridge from "components/PushFromNativeBridge";

import { connect } from 'react-redux'
import { useCanViewChannelsModule } from "hooks/useChannelsPage";
const NotFound = lazy(() => import("../../components/NotFound"))

const Main = withRouter(props => {
  const { pathname, search } = props.location;
  const isUserAuthenticated = isAuthenticated();
  pathAfterLogin.setPath(pathname, isUserAuthenticated, search)
  const canViewChannels = useCanViewChannelsModule()
  const [showMoodModal, setShowMoodModal] = useState(false);
  const [showTermsOfUseModal, setShowTermsOfUseModal] = useState(false);
  const hasToChangePassword = () => {
    const token = getToken()
    if(!token) {
      localStorage.setItem('HAS_TO_CHANGE_PASSWORD', JSON.stringify({ hasToChangePassword: false }))
      return false
    }
    const needChangePassword = pathAfterLogin.needsPasswordChange(ProfileService, getToken)
    localStorage.setItem('HAS_TO_CHANGE_PASSWORD', JSON.stringify({ hasToChangePassword: needChangePassword }))
    return needChangePassword
  }
  const userHasToChangePassword = isUserAuthenticated && hasToChangePassword()

  useEffect(() => {
    if (!isUserAuthenticated || userHasToChangePassword) {
      setShowMoodModal(false)
      setShowTermsOfUseModal(false)
      return
    }

    const showTerms = resolveTermsOfUseVisibility(props.teamConfig)
    setShowTermsOfUseModal(showTerms)

    if (showTerms) {
      setShowMoodModal(false)
      return
    }

    shouldShowMoodModalOnLogin(setShowMoodModal)
  }, [isUserAuthenticated, pathname, userHasToChangePassword, props.teamConfig])

  const handleTermsOfUseAccept = () => {
    setShowTermsOfUseModal(false)
    shouldShowMoodModalOnLogin(setShowMoodModal)
  }

  const shouldRedirect = () => {
    return [
      "/login",
      "/mfa",
      "/mfa/choose",
      "/mfa-multiple-questions",
      "/sso",
      "/start",
      "/forgot",
      "/first-access",
      "/first-access/select-method",
      "/",
    ].every(p => p !== pathname) &&
    !SSOService.isSsoLoginPath(pathname) &&
    !pathname.match(/^\/sharedWiki\/wiki\/[0-9]+\/[0-9]+(.+)?/)
  }
  const handleBottomMenu = () => {
    return isEmbeded() ||
    (pathname.match(/^\/sharedWiki\/wiki\/[0-9]+\/[0-9]+(.+)?/) && !isUserAuthenticated) ||
    userHasToChangePassword ||
    SSOService.isSsoLoginPath(pathname) ||
    (pathname.match(/^\/channel\/[^/]+/)) ||
    [
      "/",
      "/chat",
      "/login",
      "/start",
      "/sso",
      "/forgot",
      "/first-access",
      "/first-access/select-method",
      '/chatbot2', 
      "/mfa",
      "/mfa/choose",
      "/mfa-multiple-questions",
      "/mfa/multiple-questions/settings",
    ].includes(pathname)
  }
  return (
    <ContainerStyled>
      <AddToHomeScreemServiceWorker  />
      {isUserAuthenticated && canViewChannels && <ChannelSyncActivator />}
      {isUserAuthenticated && <PushFromNativeBridge />}
      <Suspense fallback={<Loading />}>
        {isUserAuthenticated && !handleBottomMenu() ? (
          <BottomMenu
            selected={pathname}
            color1={props.teamConfig.color2}
            color2={props.teamConfig.colorDisabled}
            hasBeebot={props.teamConfig.hasBeebot === 'true'}
            teamVisualIdentity={props.teamVisualIdentity}
          />
        ) : null}
        {!isUserAuthenticated &&
        (shouldRedirect()) ? (
          <Redirect to={{ pathname: "/", state: { from: props.location } }}/>
        ) : userHasToChangePassword && pathname !== '/reset' ? (
          <Redirect to="/reset" />
        ) : (
          <Switch>
            {routes.map(route => (
              <AppRoute key={route.path} {...route} />
            ))}
            <Route path="/*" component={NotFound}/>
          </Switch>
        )}
        {isUserAuthenticated && !userHasToChangePassword && (
          <>
            <MoodModal
              isOpen={showMoodModal}
              setIsOpen={setShowMoodModal}
            />
            {showTermsOfUseModal && (
              <ModalPrivacy isOpen={true} onAccept={handleTermsOfUseAccept} />
            )}
          </>
        )}
      </Suspense>

    </ContainerStyled>
  )});

const mapStateToProps = (state) => ({
  teamVisualIdentity: state.teamState.visualIdentity,
  teamConfig: state.teamState.config
})

export default memo(connect(mapStateToProps, null)(Main))
